import React from "react";
import { useStyles } from "./styles";

const LoaderSpinner = ({ info }) => {
  const classes = useStyles();

  return (
    <div className={classes.loaderContainer}>
      <div className={classes.loader}></div>

      {info && <div className={classes.info}>{info}</div>}
    </div>
  );
};

export default LoaderSpinner;
